import React from 'react';
import DataTable from 'components/data-table';
import {DetailTaiLieuRowItem} from 'modules/giai-quyet-don/datatable/rowItem'
import {header} from "constants/table";
import classnames from 'classnames';

class DanhSachBangChung extends React.Component {
  render() {
    let dataLTL = [];
    let check = false;
    if (this.props.listTaiLieuBangChung && this.props.listTaiLieuBangChung.length > 0) {
      dataLTL = this.props.listTaiLieuBangChung;
      check = true;
    } else if (this.props.listTLBC && this.props.listTLBC.length > 0) {
      dataLTL = this.props.listTLBC;
      check = true;
    }
    return (
      <div>
        <div className="title">
          <div className="rows">
              <div className="col-12">
                <h3>Danh sách tài liệu kèm theo</h3>
              </div>
          </div>
        </div>
        <div className={classnames('items-form white-table', {checktdgs: check})}>
          <div className="rows">
           <div className="col-12">
              <DataTable
                header = {header.giaiQuyetDon.danhSachBangChung}
                dataList = {dataLTL}
                type = "handle-letter-detail" hidePagination={true}
                checkTDGS = {this.props.checkTDGS}
                hiddenButtonExport>
                <DetailTaiLieuRowItem/>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DanhSachBangChung.defaultProps = {
  listTaiLieuBangChung: []
}

export default DanhSachBangChung;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/DanhSachBangChung.jsx